<template>
    <v-form ref="form" @submit.prevent>
        <v-layout class="password-creation" row wrap>
            <v-flex xs12 py-0>
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Anrede*' | translation }}</p>
                <v-select
                    v-model="salutation"
                    :items="salutations"
                    :rules="[rules.required]"
                    :label="inputLabelOutside ? '' : $language.translate('Anrede*')"
                    required
                    :solo="inputSolo"
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 py-0>
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Vorname*' | translation }}</p>
                <v-text-field
                    v-model="firstName"
                    :rules="[rules.required, rules.firstName]"
                    :label="inputLabelOutside ? '' : $language.translate('Vorname*')"
                    required
                    :solo="inputSolo"
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 py-0>
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Nachname*' | translation }}</p>
                <v-text-field
                    v-model="lastName"
                    :rules="[rules.required]"
                    :label="inputLabelOutside ? '' : $language.translate('Nachname*')"
                    required
                    :solo="inputSolo"
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 py-0 v-if="!isUserLoggedIn">
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Email*' | translation }}</p>
                <v-text-field
                    v-model="email"
                    :rules="[rules.required, rules.email]"
                    :label="inputLabelOutside ? '' : $language.translate('Email*')"
                    required
                    :solo="inputSolo"
                    :error-messages="errors['email']"
                    @change="resetErrors('email')"
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 v-if="!isUserLoggedIn && askPassword" py-0>
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Passwort*' | translation }}</p>
                <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :rules="[rules.required, rules.length]"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    :label="inputLabelOutside ? '' : $language.translate('Passwort*')"
                    required
                    :solo="inputSolo"
                    browser-autocomplete="new-password"
                    :error-messages="errors['password']"
                    @change="resetErrors('password')"
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
    import Vue from 'vue';
    import module from '../../store/registration';
    import { mapState, mapGetters, createNamespacedHelpers } from 'vuex';
    import Login from '@breakmedia/prime-vue-customer/src/Login/LoginForm';

    const moduleName = 'Registration';
    const {mapMutations} = createNamespacedHelpers(moduleName);

    if (!Vue.$store.state[moduleName]) {
        Vue.$store.registerModule(moduleName, module);
    }

    export default {
        name: moduleName,
        data: () => ({
            showPassword: false,
            rules:  {
                required: value => !!value || 'Dieses Feld wird benötigt und darf nicht leer sein.',
                length: value => (value ? (value.length >= 7 || 'Das Passwort muss mindestens 7 Zeichen haben.') : ''),
                email: value => /.+@.+/.test(value) || 'Bitte geben sie eine gültige Email-Adresse ein.',
                firstName: value => value ? (new RegExp('[a-zA-Z]{2}', 'i').test(value) || 'Das Vorname muss mindestens 2 Zeichen haben.') : '',
            },
            salutations: [
                {
                    text: 'Frau',
                    value: 'frau',
                },
                {
                    text: 'Herr',
                    value: 'herr',
                },
            ],
        }),
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            inputSolo: Boolean,
            inputLabelOutside: Boolean,
            askPassword: Boolean,
        },
        computed: {
            ...mapState(moduleName, {
                errors: state => state.errors,
            }),
            ...mapState('Customer', [
                'customerData',
            ]),
            ...mapState('Login.name', [
                'login',
            ]),
            ...mapGetters(Login.name, [
                'isUserLoggedIn',
            ]),
            salutation: {
                get() {
                    return this.getSalutation();
                },
                set(value) {
                    this.setSalutation(value);
                },
            },
            firstName: {
                get() {
                    return this.getFirstName();
                },
                set(value) {
                    this.setFirstName(value);
                },
            },
            lastName: {
                get() {
                    return this.getLastName();
                },
                set(value) {
                    this.setLastName(value);
                },
            },
            email: {
                get() {
                    return this.getEmail();
                },
                set(value) {
                    this.setEmail(value);
                },
            },
            password: {
                get(){
                    return this.getPassword();
                },
                set(value){
                    this.setPassword(value);
                },
            },
        },
        methods: {
            ...mapGetters(moduleName, [
                'getSalutation',
                'getFirstName',
                'getLastName',
                'getEmail',
                'getPassword',
            ]),
            ...mapMutations([
                'setSalutation',
                'setFirstName',
                'setLastName',
                'setEmail',
                'setPassword',
            ]),
            ...mapMutations({
                'resetErrorsMutation': 'resetErrors',
            }),
            resetErrors() {
                this.resetErrorsMutation();
            },
            validate(){
                return this.$refs.form.validate();
            },
        },
        watch: {
            'customerData.email': {
                immediate: true,
                handler(value) {
                    this.setEmail(value);
                },
            },
            'login': {
                immediate: true,
                handler(value) {
                    this.setEmail(value);
                },
            },
        },
    };
</script>
